import { observable } from 'mobx';
import { WebGivingPage } from '../index';
import { FormField } from '../../components/form-field';
import { ValidationState, validateFields } from '../../validation/view-model-validator';
import { createRulesFromMetadata } from '../../validation/validation-rules';
import { ModelMetadata } from '../../webgiving-generated';
import { WebGivingPageViewModelBase } from '../page-view-model-base';

export class PageCreateAccountViewModel extends WebGivingPageViewModelBase {
	readonly type: WebGivingPage.CreateAccount = WebGivingPage.CreateAccount;

	@observable
	validationState?: ValidationState;

	firstName: FormField<string>;

	lastName: FormField<string>;

	emailAddress: FormField<string>;

	readonly subTitle: string;

	constructor (firstName: string = '', lastName: string = '', emailAddress: string = '', accountCreationText = '') {
		super();
		this.firstName = new FormField<string>(firstName, createRulesFromMetadata(ModelMetadata.CreateAccountRequest.FirstName));
		this.lastName = new FormField<string>(lastName, createRulesFromMetadata(ModelMetadata.CreateAccountRequest.LastName));
		this.emailAddress = new FormField<string>(emailAddress, createRulesFromMetadata(ModelMetadata.CreateAccountRequest.Email));
		this.subTitle = accountCreationText;
	}

	validate(): ValidationState {
		return validateFields(this);
	}
}
